import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    getPAGAA000,
    postPABAA010event,
    postPABAA010news,
    postPABAA010recruit,
    postPABAA010resume,
} from '../../services/Api';
import Tabs from '../../shared/components/Tabs';
import SearchEvents from './Events';
import SearchNews from './News';
import SearchRecruits from './Recruits';
import SearchResumes from './Resumes';
import SearchNotFound from './SearchNotFound';
import { shouldDisplayMenu } from '../../utils';

const PABAA010 = () => {
    const [menuData, setMenuData] = useState([]);
    const [searchParams] = useSearchParams();
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const keyword = searchParams.get('keyword');
    const navigate = useNavigate();

    const [resumes, setResumes] = useState([]);
    const [pagesResume, setPagesResume] = useState({});
    const pageResume = Number(searchParams.get('pageResume')) || 1;

    const [recruits, setRecuits] = useState([]);
    const singleTab = true;
    const [pagesRecruit, setPagesRecruit] = useState({});
    const pageRecruit = Number(searchParams.get('pageRecruit')) || 1;

    const [news, setNews] = useState([]);
    const [pagesNews, setPagesNews] = useState({});
    const pageNews = Number(searchParams.get('pageNews')) || 1;

    const [events, setEvents] = useState([]);
    const [pagesEvent, setPagesEvent] = useState({});
    const pageEvent = Number(searchParams.get('pageEvent')) || 1;

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                setMenuData(data);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        if (!keyword || keyword.trim() === '') {
            navigate('/');
        }
    }, [keyword, navigate]);

    const handleTabChange = useCallback((index) => {
        setActiveTabIndex(index);
    }, []);

    const getDataRecruit = () => {
        postPABAA010recruit({
            page: pageRecruit,
            optionLike: {
                [keyword]: ['CompanyName', 'Title', 'BizAddrDesc', 'BizAddr'],
            },
            sortBy: 'modDate',
            size: 5,
        })
            .then(({ data }) => {
                setRecuits(data.data.list);
                setPagesRecruit(data.info);
            })
            .catch((error) => console.log(error));
    };

    const getDataResume = () => {
        postPABAA010resume({ page: pageResume, keyword, size: 5 })
            .then(({ data }) => {
                setResumes(data.data);
                setPagesResume(data.info);
            })
            .catch((error) => console.log(error));
    };

    const getDataNews = () => {
        postPABAA010news({ page: pageNews, keyword, size: 5 })
            .then(({ data }) => {
                setNews(data.data);
                setPagesNews(data.info);
            })
            .catch((error) => console.log(error));
    };
    const getDataEvent = () => {
        postPABAA010event({ page: pageEvent, keyword, size: 5 })
            .then(({ data }) => {
                setEvents(data.data);
                setPagesEvent(data.info);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        getDataRecruit();
        // eslint-disable-next-line
    }, [keyword, pageRecruit]);
    useEffect(() => {
        getDataResume();
        // eslint-disable-next-line
    }, [keyword, pageResume]);
    useEffect(() => {
        getDataNews();
        // eslint-disable-next-line
    }, [keyword, pageNews]);
    useEffect(() => {
        getDataEvent();
        // eslint-disable-next-line
    }, [keyword, pageEvent]);

    const tabs = useMemo(() => {
        const baseTabs = [
            { label: '통합검색', isActive: true },
            { label: '채용정보', isActive: false },
            { label: '인재정보', isActive: false },
            { label: '공지/소식', isActive: false },
            { label: '이벤트', isActive: false },
        ];

        return baseTabs.filter(
            (tab) =>
                !(tab.label === '공지/소식' && !shouldDisplayMenu('pahaf010', menuData)) &&
                !(tab.label === '이벤트' && !shouldDisplayMenu('pagab010', menuData)),
        );
    }, [menuData]);

    const renderTabContent = (list, Component, pages, singleTab, setListData) => {
        if (list?.length > 0) {
            return <Component list={list} pages={pages} setListData={setListData} />;
        }
        return singleTab ? <SearchNotFound /> : null;
    };
    return (
        <div id="content">
            <div id="search-content">
                <div className="container">
                    <h4 className="title-results">전체검색결과</h4>
                    <Tabs tabs={tabs} onTabChange={handleTabChange} />
                    <div className="results-text">
                        <span className="keyword">'{keyword}'</span>
                        <span className="results-default-text">에 대한 검색결과입니다.</span>
                    </div>
                    {activeTabIndex === 0 && (
                        <>
                            {!recruits && !resumes && !news && !events && <SearchNotFound />}
                            {renderTabContent(recruits, SearchRecruits, pagesRecruit, false, setRecuits)}
                            {renderTabContent(resumes, SearchResumes, pagesResume, false, setResumes)}
                            {shouldDisplayMenu('pahaf010', menuData) &&
                                renderTabContent(news, SearchNews, pagesNews, false)}
                            {shouldDisplayMenu('pagab010', menuData) &&
                                renderTabContent(events, SearchEvents, pagesEvent, false)}
                        </>
                    )}
                    {activeTabIndex === 1 &&
                        renderTabContent(recruits, SearchRecruits, pagesRecruit, singleTab, setRecuits)}
                    {activeTabIndex === 2 &&
                        renderTabContent(resumes, SearchResumes, pagesResume, singleTab, setResumes)}
                    {activeTabIndex === 3 &&
                        shouldDisplayMenu('pahaf010', menuData) &&
                        renderTabContent(news, SearchNews, pagesNews, singleTab)}
                    {activeTabIndex === 4 &&
                        shouldDisplayMenu('pagab010', menuData) &&
                        renderTabContent(events, SearchEvents, pagesEvent, singleTab)}
                </div>
            </div>
        </div>
    );
};

export default PABAA010;
